import { type GetVehicleSpecificationStatisticsResponseVM } from '@/app/services/solution/types/get-vehicle-specification-statistics';

const vehicleSpecificationStatistics: GetVehicleSpecificationStatisticsResponseVM = {
  maxRangeKm: 450,
  dailyBatteryUsagePercent: 85,
  energyConsumptionKwhPerKm: 2,
  cycledEnergyKwhPerKm: 4,
};

export default vehicleSpecificationStatistics;
